import { ref, watch } from '@vue/composition-api'

const useDropdown = () => {
    const initialDropdownData = [
        {
            icon: 'category',
            title: 'Category',
            key: 'category',
            list: [
                {text: 'Apparel', value: 'apparel'},
                {text: 'Home & Garden', value: 'home and garden'},
                {text: 'Pets & Animals', value: 'pets and animals'},
                {text: 'Beauty & Fitness', value: 'beauty and fitness'},
                {text: 'Sports', value: 'sports'},
            ]
        },
        {
            icon: 'monthly-sales',
            title: 'Monthly Sales',
            key: 'monthlySales',
            list: [
                {text: 'less than $30,000', value: [0, 30000]},
                {text: '$30,000 - $70,000', value: [30000, 70000]},
                {text: '$70,000 - $100,000', value: [70000, 100000]},
                {text: '$100,000 - $150,000', value: [100000, 150000]},
                {text: '$150,000 - $180,000', value: [150000, 180000]},
                {text: '$180,000 - $230,000', value: [180000, 230000]},
                // 1000000000000 instead of Infinity
                {text: 'more than $230,000', value: [230000, 1000000000000]}
            ]
        }
    ]

    return {
        initialDropdownData
    }
}
export default useDropdown